export * from "./message.component";
